import { where } from 'firebase/firestore';
import { fetchByTable, addDataToTable, updateDataById } from '../utils';

export const addTokens = async (id, data, setLoading) =>
  updateDataById({ id, tableName: 'users', data, setLoading });

export const fetchUsers = async setLoading =>
  fetchByTable({ tableName: 'users', orderByField: 'nickname', setLoading });

export const addPlace = async (data, setLoading) =>
  addDataToTable({ tableName: 'fields', data, setLoading });
